import React from 'react';
import { breakpoints } from '../config';

const Animation = ({ src, poster }) => (
  <div>
    <video autoPlay loop muted playsInline src={src} poster={poster} />

    <style jsx>{`
      video {
        height: auto;
        width: 100%;
        border-radius: 4px;
        margin-bottom: 30px;
        background-color: #fff;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        div {
          background-color: #f1f1f1;
          border-radius: 4px;
          height: 272px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          margin-bottom: 40px;
        }

        video {
          margin-bottom: 0 !important;
          width: 75%;
          box-shadow: 0 64px 64px 0 rgba(89, 76, 58, 0.05), 0 32px 32px 0 rgba(120, 109, 61, 0.05),
            0 16px 16px 0 rgba(82, 69, 55, 0.05), 0 8px 8px 0 rgba(125, 109, 72, 0.05),
            0 4px 4px 0 rgba(125, 114, 64, 0.05), 0 2px 2px 0 rgba(115, 102, 63, 0.05);
        }
      }
    `}</style>
  </div>
);

export default Animation;
